// extracted by mini-css-extract-plugin
var _1 = "XucyU";
var _2 = "XVRfD";
var _3 = "SwJuR";
export { _1 as "base", _2 as "delete", _3 as "value" }
